export default __webpack_public_path__ + "static/media/25_gallery.814ecaaa.jpg";